import * as constants from "../../constants/fixture.constants";

export const optaIdError = (value: string): string => {
    const trimmed = value.trim();
    if (trimmed === "") return "";
    if (/^g\d+$/i.test(trimmed)) return constants.OPTA_ID_LEADING_G;
    if (!/^\d+$/.test(trimmed)) return constants.OPTA_ID_INVALID;
    return "";
};
